import { useLocalization } from "@/data/Localization";
import { displayStoreWithStock } from "@/data/types/Store";
import { Box, Button, Stack, Typography } from "@mui/material";
import { FC, useContext, useState } from "react";
import { pickStoreBtnSx } from "../styles/storeDetailsDisplay";
import { StoreStockDetailsDisplay } from "./StoreStockDetailsDisplay";
import { StoreDetailsPopup } from "./StoreDetailsPopup";
import { ContentContext } from "@/data/context/content";
import { useClickAndCollect } from "@/data/Content/ClickAndCollect";

type Props = {
    setSelectedStore:(store:displayStoreWithStock | undefined)=>void
}

export const StoreDetailsDisplay: FC<Props> = ({ setSelectedStore }) => {
    const ClickAndCollectNLS = useLocalization("ClickAndCollect");
    const [popupStoreAndFeature, setPopupStoreAndFeature] = useState<displayStoreWithStock>();

    const {
        displayStores,
    } = useContext(ContentContext) as ReturnType<typeof useClickAndCollect>;
    
    return (
        <>
            {displayStores?.map(({store, feature, stock}) =>
                <Stack py={0.5} direction="row" justifyContent="space-between" alignItems="center" columnGap={1}>
                    <Box>
                        <Typography variant="h4" pb={0} onClick={()=>setPopupStoreAndFeature({store, feature, stock})} sx={{cursor:'pointer'}}>
                            {store.storeName}&#40;{parseFloat(store.distance).toFixed(2)}km&#41;
                        </Typography>
                        <Stack>
                            <Box>
                                <Typography>{store.displayAddress},{store.city}</Typography>
                            </Box>
                            <StoreStockDetailsDisplay {...{store, stock, storeFeature:feature}} />
                        </Stack>
                    </Box>
                    <Button variant="contained" sx={pickStoreBtnSx} onClick={()=>setSelectedStore({store, feature, stock})}>
                        {ClickAndCollectNLS.PickUPAtThisStore.t()}
                    </Button>
                </Stack>
            )}

            {popupStoreAndFeature &&
                <StoreDetailsPopup {...{popupStoreAndFeature, setPopupStoreAndFeature}} />
            }
            
        </>

    );
}